<h1 mat-dialog-title class="text-center dialogHeader blueHeader">
  Hard Reset Password
</h1>
<mat-dialog-content class="contentWid">
  <div class="col-md-12 loggedin-bg">
    <div class="row mt-3">
      <div class="col-md-5">
        <label for="userId" class="mt-2">Email Id</label>
      </div>
      <div class="col-md-7">
        <input
          type="text"
          [(ngModel)]="emailId"
          [ngModelOptions]="{ standalone: true }"
          class="form-control ml-3"
          maxlength="30"
          id="userId"
          #newPasswordInput
          placeholder="Enter Email Id"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-5">
        <label for="newPasswordInput" class="mt-2">New Password</label>
      </div>
      <div class="col-md-7">
        <label
          for="newPasswordInput"
          class="fa fa-eye-slash eye"
          [ngClass]="{
            'fa-eye-slash': showNewPassword,
            'fa-eye': !showNewPassword
          }"
          (click)="
            newPasswordInput.type =
              newPasswordInput.type == 'password' ? 'text' : 'password';
            showNewPassword = !showNewPassword
          "
        ></label>
        <input
          type="password"
          [(ngModel)]="newPassword"
          [ngModelOptions]="{ standalone: true }"
          class="form-control ml-3"
          maxlength="30"
          id="newPasswordInput"
          #newPasswordInput
          placeholder="New Password"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-5">
        <label for="confirmNewpasswordInput" class="mt-2">Confirm New Password</label>
      </div>
      <div class="col-md-7">
        <label
          for="confirmNewpasswordInput"
          class="fa fa-eye-slash eye"
          [ngClass]="{
            'fa-eye-slash': shownConfirmPassword,
            'fa-eye': !shownConfirmPassword
          }"
          (click)="
            confirmNewpasswordInput.type =
              confirmNewpasswordInput.type == 'password' ? 'text' : 'password';
            shownConfirmPassword = !shownConfirmPassword
          "
        ></label>
        <input
          type="password"
          [(ngModel)]="confirmPassword"
          [ngModelOptions]="{ standalone: true }"
          class="form-control ml-3"
          maxlength="30"
          id="confirmNewpassword"
          #confirmNewpasswordInput
          placeholder="Confirm New Password"
        />
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="col-md-8 offset-md-2 mb-3">
    <button
      mat-button
      class="btnWidth blankTurquoise mr-4 btn wid"
      (click)="dialogRef.close(false)"
    >
      CANCEL
    </button>
    <button
      mat-button
      class="btnWidth turquoiseBtn btn wid ml-4"
      (click)="resetPassword()"
    >
      Reset
    </button>
  </div>
</mat-dialog-actions>
